// extracted by mini-css-extract-plugin
module.exports = {"spanButton":"styles_spanButton__V_CxO","button":"styles_button__jWSpa","img":"styles_img___0_Lb"};